import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Phone, CheckCircle2, ArrowLeft } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { COMPANY, SERVICE_IMG, SERVICE_DETAILS } from "@/data/company";
import { Icon } from "@/lib/icons";
import CallbackForm from "@/components/site/CallbackForm";
import { useSeo } from "@/lib/useSeo";

export default function ServiceDetail() {
  const { slug } = useParams();
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => {}); }, []);
  const service = services.find((s) => s.slug === slug);
  useSeo(service ? service.title : "Service", service ? service.short : "");
  const details = SERVICE_DETAILS[slug] || [];

  return (
    <div>
      <section className="relative pt-32 pb-20">
        <div className="absolute inset-0"><img src={fileUrl(SERVICE_IMG[slug])} alt="" className="w-full h-full object-cover" /><div className="absolute inset-0 bg-gradient-to-r from-ink/90 to-ink/50" /></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/services" className="inline-flex items-center gap-2 text-white/70 hover:text-primary text-sm mb-4"><ArrowLeft size={16} /> Tous les services</Link>
          {service && (
            <>
              <div className="h-12 w-12 rounded-xl bg-primary flex items-center justify-center text-white mb-4"><Icon name={service.icon} size={24} /></div>
              <h1 className="font-heading text-4xl sm:text-5xl font-black text-white max-w-3xl">{service.title}</h1>
              <p className="mt-4 text-white/80 max-w-2xl text-lg">{service.short}</p>
            </>
          )}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 lg:grid-cols-3 gap-12">
        <div className="lg:col-span-2">
          <h2 className="font-heading text-2xl font-black text-ink">Nos prestations</h2>
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {details.map((d) => (
              <div key={d} className="flex items-start gap-3 bg-card border border-border rounded-xl p-4">
                <CheckCircle2 size={20} className="text-primary shrink-0 mt-0.5" />
                <span className="text-ink/80 text-sm font-medium">{d}</span>
              </div>
            ))}
          </div>
          <div className="mt-10 bg-secondary/40 rounded-2xl p-8">
            <h3 className="font-heading text-xl font-bold text-ink">Pourquoi choisir SMT Provence ?</h3>
            <p className="mt-3 text-ink/70 leading-relaxed">
              Nous mettons un point d'honneur à réaliser chaque ouvrage dans le respect des règles de l'art, pour assurer la solidité et la pérennité de vos constructions.
              Interlocuteur unique, matériaux de qualité et devis transparent : nous accompagnons particuliers, professionnels et collectivités à chaque étape.
            </p>
            <a href={`tel:${COMPANY.phoneHref}`} className="mt-5 inline-flex items-center gap-2 bg-ink text-white px-6 py-3 rounded-full font-bold hover:bg-primary transition"><Phone size={18} /> {COMPANY.phone}</a>
          </div>
        </div>
        <div className="lg:col-span-1">
          <div className="bg-card border border-border rounded-2xl p-6 sticky top-24">
            <h3 className="font-heading text-xl font-bold text-ink">Demande de rappel</h3>
            <p className="text-sm text-ink/60 mt-1 mb-4">Gratuit & sans engagement.</p>
            <CallbackForm defaultService={service?.title || ""} source={`service:${slug}`} />
          </div>
        </div>
      </section>
    </div>
  );
}
